import React, {useState} from 'react';
import {Box, Typography, TextField, Select, MenuItem} from '@mui/material';
import RadioButton from '../../components/RadioButton';
import '../../css/OutPutDirectory.css'; // Import the CSS file
import {useDispatch, useSelector} from 'react-redux';
import {saveFormDetails} from '../../redux/slices/CreateAgentSlice';
import { FORM_KEYS} from '../../utills/constant';

const OutPutDirectory = () => {
  const dispatch = useDispatch ();
  const formDetails = useSelector (state => state.CreateAgentSlice.formDetails);
  console.log ('formDetails', formDetails);
  // The array of directories
  const [directory, setDirectory] = useState ([
    { id: 'Azure', name: "Nuvento Blob Storage" }, // DO NOT CHANGE
  ]);

  const setFormDetailsValue = (key, value) => {
    dispatch (saveFormDetails ({key, value}));
  };

  // State to track the selected directory's id
  const [selectedDirectory, setSelectedDirectory] = useState ('');

  // Handle onChange
  const handleChange = event => {
    setSelectedDirectory (event.target.value);
    setFormDetailsValue(FORM_KEYS.OUTPUT_DIRECTORY_ID, event.target.value);
  };
  return (
    <div className="output-directory-container">
      <Box className="format-box">
        <h2 className="format-title">
          FORMAT
        </h2>
        <RadioButton setFormDetailsValue={setFormDetailsValue}/>
      </Box>

      <Box className="select-directory-box">
        <Typography sx={{color: '#000', fontWeight: 'bold'}}>
          Select Output Directory
        </Typography>

        <Box className="select-directory">
          <Select
            value={formDetails[FORM_KEYS.OUTPUT_DIRECTORY_ID]}
            onChange={e => handleChange(e)}
            fullWidth
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select  Directory
            </MenuItem>
            {directory.map (dir => (
              <MenuItem key={dir.id} value={dir.id}>
                {dir.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box className="form-fields-container">
          <Box className="form-field">
            <Typography sx={{color: '#000', fontWeight: 'bold'}}>
              Save output files to:
            </Typography>
            <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
            URL / Path
            </Typography>
            <TextField
               value={formDetails[FORM_KEYS.OUTPUT_DIRECTORY_PATH_OR_ADDRESS]}
              onChange={(event)=>setFormDetailsValue(FORM_KEYS.OUTPUT_DIRECTORY_PATH_OR_ADDRESS,event.target.value)}
            className="text-field" placeholder="Enter  URL / PATH" />
          </Box>

          <Box className="form-field">
            <Typography sx={{color: '#000', fontWeight: 'bold'}}>
              Move processed files to:
            </Typography>
            <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
            URL / Path
            </Typography>
            <TextField
              value={formDetails[FORM_KEYS.PROCESSED_FILE_DIRECTORY_PATH_OR_ADDRESS]}
              onChange={(event)=>setFormDetailsValue(FORM_KEYS.PROCESSED_FILE_DIRECTORY_PATH_OR_ADDRESS,event.target.value)}
            className="text-field" placeholder="Enter  URL / PATH" />
          </Box>

          <Box className="form-field">
            <Typography sx={{color: '#000', fontWeight: 'bold'}}>
              Move rejected files to:
            </Typography>
            <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
            URL / Path
            </Typography>
            <TextField 
             value={formDetails[FORM_KEYS.REJECTED_FILE_DIRECTORY_PATH_OR_ADDRESS]}
            onChange={(event)=>setFormDetailsValue(FORM_KEYS.REJECTED_FILE_DIRECTORY_PATH_OR_ADDRESS,event.target.value)} className="text-field" placeholder="URL Address" />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default OutPutDirectory;
